import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Semantic spacing tokens used across the project.
 * These must be registered with tailwind-merge so it can resolve
 * conflicts like `p-md p-sm` → `p-sm`.
 */
const SEMANTIC_SPACING = ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', 'xs2'] }],
      p: [{ p: [...SEMANTIC_SPACING] }],
      px: [{ px: [...SEMANTIC_SPACING] }],
      py: [{ py: [...SEMANTIC_SPACING] }],
      pt: [{ pt: [...SEMANTIC_SPACING] }],
      pr: [{ pr: [...SEMANTIC_SPACING] }],
      pb: [{ pb: [...SEMANTIC_SPACING] }],
      pl: [{ pl: [...SEMANTIC_SPACING] }],
      ps: [{ ps: [...SEMANTIC_SPACING] }],
      pe: [{ pe: [...SEMANTIC_SPACING] }],
      m: [{ m: [...SEMANTIC_SPACING] }],
      mx: [{ mx: [...SEMANTIC_SPACING] }],
      my: [{ my: [...SEMANTIC_SPACING] }],
      mt: [{ mt: [...SEMANTIC_SPACING] }],
      mr: [{ mr: [...SEMANTIC_SPACING] }],
      mb: [{ mb: [...SEMANTIC_SPACING] }],
      ml: [{ ml: [...SEMANTIC_SPACING] }],
      ms: [{ ms: [...SEMANTIC_SPACING] }],
      me: [{ me: [...SEMANTIC_SPACING] }],
      gap: [{ gap: [...SEMANTIC_SPACING] }],
      'gap-x': [{ 'gap-x': [...SEMANTIC_SPACING] }],
      'gap-y': [{ 'gap-y': [...SEMANTIC_SPACING] }],
      'space-x': [{ 'space-x': [...SEMANTIC_SPACING] }],
      'space-y': [{ 'space-y': [...SEMANTIC_SPACING] }]
    }
  }
});

/**
 * Utility function to merge Tailwind CSS classes with proper conflict resolution
 * @param inputs - Class values to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
